import { CartItem, Category } from '../types';

export interface GroupedCategory {
  categoryId: string;
  categoryName: string;
  items: CartItem[];
}

export const groupItemsByCategory = (
  items: CartItem[],
  categories: Category[]
): GroupedCategory[] => {
  const categoryMap = new Map<string, GroupedCategory>();
  const uncategorizedKey = 'uncategorized';

  for (const item of items) {
    const categoryId = item.menuItem.category || uncategorizedKey;

    if (!categoryMap.has(categoryId)) {
      const category = categories.find((c) => c._id === categoryId);
      const categoryName = category?.name?.[0] || 'Autres';

      categoryMap.set(categoryId, {
        categoryId,
        categoryName,
        items: [],
      });
    }

    categoryMap.get(categoryId)!.items.push(item);
  }

  const sortedGroups: GroupedCategory[] = [];
  for (const category of categories) {
    if (categoryMap.has(category._id)) {
      sortedGroups.push(categoryMap.get(category._id)!);
      categoryMap.delete(category._id);
    }
  }

  for (const remaining of categoryMap.values()) {
    sortedGroups.push(remaining);
  }

  return sortedGroups;
};

export const getCategoryNameById = (
  categoryId: string,
  categories: Category[]
): string => {
  const category = categories.find((c) => c._id === categoryId);
  return category?.name?.[0] || 'Autres';
};
